(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-navigation"] && !Shopify.designMode) return;
  try {
    const initializeBrandNavigation = (root) => {
    if (root.dataset.brandNavigationReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-brand-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-brand-panel]'));

    const activate = (tab, moveFocus = false) => {
      const panelId = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(tab);
      });
      tab.addEventListener('mouseenter', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          activate(tabs[nextIndex], true);
        }
      });
    });

    root.dataset.brandNavigationReady = 'true';
  };

  const initializeAllBrandNavigation = (scope = document) => {
    scope.querySelectorAll('[data-brand-navigation]').forEach(initializeBrandNavigation);
  };

  initializeAllBrandNavigation();
  document.addEventListener('shopify:section:load', (event) => initializeAllBrandNavigation(event.target));
  } catch(e) { console.error(e); }
})();

})();
